import { ShiftOffersFieldGroupValue, ShiftOffersFieldGroupErrors } from './types';

export default shiftOffersFieldGroupValidator;

export function shiftOffersFieldGroupValidator(values: ShiftOffersFieldGroupValue) {
  const errors: ShiftOffersFieldGroupErrors = {};

  return errors;
}
